export const TECH_DETAIL_CONFIG = {
  react: {
    title: "React",
    subtitle: "ls techstack/react/",
    storageKey: "techDetail:react:typed:v1",
    lines: [
      { type: "prompt", text: "cat profile.md" },
      { type: "response", text: "ui-entwicklung fuer produktive web-apps und dashboards." },
      { type: "response", text: "fokus: komponentenarchitektur, state, performance und wartbarkeit." },
      { type: "prompt", text: "cat usage.md" },
      { type: "response", text: "eingesetzt fuer kundenportale, interne tools und komplexe frontends." },
      { type: "status", text: "bereit fuer react-sparring -> Saghallo" },
    ],
  },
  angular: {
    title: "Angular",
    subtitle: "ls techstack/angular/",
    storageKey: "techDetail:angular:typed:v1",
    lines: [
      { type: "prompt", text: "cat profile.md" },
      { type: "response", text: "strukturierte enterprise-frontends mit klaren modulen und standards." },
      { type: "response", text: "fokus: langlebigkeit, teamfaehigkeit und saubere release-prozesse." },
      { type: "prompt", text: "cat usage.md" },
      { type: "response", text: "eingesetzt fuer umfangreiche business-anwendungen und plattformen." },
      { type: "status", text: "bereit fuer angular-review -> Saghallo" },
    ],
  },
  flutter: {
    title: "Flutter",
    subtitle: "ls techstack/flutter/",
    storageKey: "techDetail:flutter:typed:v1",
    lines: [
      { type: "prompt", text: "cat profile.md" },
      { type: "response", text: "cross-platform apps mit konsistentem ux und hoher entwicklungsdynamik." },
      { type: "response", text: "fokus: schnelle iteration, klare komponenten und stabile builds." },
      { type: "prompt", text: "cat usage.md" },
      { type: "response", text: "eingesetzt fuer mobile produkte, prototypen und interne app-tools." },
      { type: "status", text: "bereit fuer app-planung -> Saghallo" },
    ],
  },
  typescript: {
    title: "TypeScript",
    subtitle: "ls techstack/typescript/",
    storageKey: "techDetail:typescript:typed:v1",
    lines: [
      { type: "prompt", text: "cat profile.md" },
      { type: "response", text: "typisierte codebasen fuer weniger fehler und bessere wartbarkeit." },
      { type: "response", text: "fokus: klare schnittstellen, refactoring-sicherheit und team-speed." },
      { type: "prompt", text: "cat usage.md" },
      { type: "response", text: "basis fuer robuste frontend- und backend-projekte." },
      { type: "status", text: "bereit fuer type-system check -> Saghallo" },
    ],
  },
  "node-js": {
    title: "Node.js",
    subtitle: "ls techstack/node/",
    storageKey: "techDetail:node:typed:v1",
    lines: [
      { type: "prompt", text: "cat profile.md" },
      { type: "response", text: "apis, automations und integrations fuer skalierbare backend-prozesse." },
      { type: "response", text: "fokus: saubere services, auth, datenfluesse und deployment." },
      { type: "prompt", text: "cat usage.md" },
      { type: "response", text: "eingesetzt fuer web-plattformen, tools und service-layer." },
      { type: "status", text: "bereit fuer api-architektur -> Saghallo" },
    ],
  },
  "three-js": {
    title: "Three.js",
    subtitle: "ls techstack/threejs/",
    storageKey: "techDetail:threejs:typed:v1",
    lines: [
      { type: "prompt", text: "cat profile.md" },
      { type: "response", text: "interaktive 3d-erlebnisse direkt im browser." },
      { type: "response", text: "fokus: performance, saubere scene-struktur und nutzbares ui." },
      { type: "prompt", text: "cat usage.md" },
      { type: "response", text: "eingesetzt fuer produktpraesentationen und immersive interfaces." },
      { type: "status", text: "bereit fuer 3d-konzept -> Saghallo" },
    ],
  },
  unity: {
    title: "Unity",
    subtitle: "ls techstack/unity/",
    storageKey: "techDetail:unity:typed:v1",
    lines: [
      { type: "prompt", text: "cat profile.md" },
      { type: "response", text: "3d/interactive prototyping fuer trainings, simulation und experiences." },
      { type: "response", text: "fokus: schnelle umsetzung und technische machbarkeitspruefung." },
      { type: "prompt", text: "cat usage.md" },
      { type: "response", text: "eingesetzt wenn interaktivitaet ueber klassische web-ux hinausgeht." },
      { type: "status", text: "bereit fuer prototyping -> Saghallo" },
    ],
  },
  python: {
    title: "Python",
    subtitle: "ls techstack/python/",
    storageKey: "techDetail:python:typed:v1",
    lines: [
      { type: "prompt", text: "cat profile.md" },
      { type: "response", text: "automatisierung, datenverarbeitung und helper-services." },
      { type: "response", text: "fokus: pragmatische loesungen, die teams entlasten." },
      { type: "prompt", text: "cat usage.md" },
      { type: "response", text: "eingesetzt fuer scripts, toolchains und workflow-optimierung." },
      { type: "status", text: "bereit fuer automation-check -> Saghallo" },
    ],
  },
};

export function toTechKey(name) {
  return name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
}
